import Request from '@hotmart-org-ca/request';
import { HotmartRum } from '@hot-observability-js/react';

import { ONBOARDING_SESSION_KEY } from '@/common/constants';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const appName = require('../../../package.json').name;

Request.setAppNameHeader(appName);

Request.setRequestInterceptor((config) => {
  config.headers = config.headers || {};
  const sessionKey = sessionStorage.getItem(ONBOARDING_SESSION_KEY);
  if (sessionKey) {
    config.headers[ONBOARDING_SESSION_KEY] = sessionKey;
  }
  config.headers['x-app-name'] = appName;
  config.headers['Company'] = 'HOTMART';
  return config;
});

Request.setResponseInterceptor(
  (response) => response,
  async (error) => {
    const filterUrl = error?.config?.url || '';
    const baseName = '/api/rest/v1/mobile/session/check';
    if (!filterUrl.includes(baseName) && error.response?.status === 401) {
      HotmartRum.captureException(error);
    } else if (!filterUrl.includes(baseName)) {
      HotmartRum.captureException(error);
    }
    if (error.response && error.response.status === 401) {
      try {
        if (error.config?.headers) {
          delete error.config.headers[ONBOARDING_SESSION_KEY];
        }
      } catch (err) {
        console.error('Session token expired:', err);
      }
    }
    return Promise.reject(error);
  }
);
